import { Injectable, inject, signal } from '@angular/core';
import { ENVIRONMENT } from './environment';

type RuntimeMode = 'electron' | 'hosted';

@Injectable({ providedIn: 'root' })
export class FeatureFlagsService {
    private readonly env = inject(ENVIRONMENT);

    public readonly mode: RuntimeMode =
        typeof window !== 'undefined' && !!(window as unknown as { privanotRuntime?: unknown }).privanotRuntime
            ? 'electron'
            : 'hosted';

    private readonly _serviceManagedByApp = signal<boolean>(false);
    public readonly serviceManagedByApp = this._serviceManagedByApp.asReadonly();

    public enabled(flag: string): boolean {
        return this.env.featureFlags?.[flag] === true;
    }

    public isElectron(): boolean {
        return this.mode === 'electron';
    }

    public isHosted(): boolean {
        return this.mode === 'hosted';
    }

    public isServiceManagedByApp(): boolean {
        return this._serviceManagedByApp();
    }

    public setServiceManagedByApp(value: boolean): void {
        this._serviceManagedByApp.set(value);
    }
}
